import { MitantragstellerDisplayModel } from "@/api/model-index";
import { MitantragstellerService } from "@/api/service-index";
import { PortalContextService } from "@/core/services/portal-context.service";
import { UnfinishedHttpMethodsService } from "@/core/services/unfinished-http-methods.service";
import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { map } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class GetMitantragstellerResolver  {
    constructor(protected mitantragstellerService: MitantragstellerService, protected portalContextService: PortalContextService, protected unfinishedHttpMethodsService: UnfinishedHttpMethodsService) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<MitantragstellerDisplayModel[]> {
        let id: string = <string>route.params['id'];

        await this.unfinishedHttpMethodsService.waitByUrl(state.url);

        if (this.portalContextService.CurrentAnfrage.mitantragsteller)
            return this.portalContextService.CurrentAnfrage.mitantragsteller;

        return this.mitantragstellerService.apiMitantragstellerGetAllMitantragstellerAnfrageIdGet({ anfrageId: id }).pipe(map(response => {
            this.portalContextService.CurrentAnfrage.mitantragsteller = response;

            return response;
        })).toPromise();;
    }
}